/**
 * 【KYMW1407】画像情報管理更新
 *
 * @export UpdateUseImageModel
 * @class UpdateUseImageModel
 */
export class UpdateUseImageModel {
  // コマID
  public komaId = String('');
  // 使用画像リスト
  public useImageList: Array<any> = new Array<any>();
}
